<template>
  <div class="card card--start">
    <div class="card__content join join--col">
      <h3>Полезные ресурсы</h3>
      <p>Получи профессию будущего – поступай в университет новых технологий!</p>
      <ul class="join join--grouped join--mobile-col">
        <a class="join__item btn btn--outline-primary" target="_blank" href="https://storage.tusur.ru/files/190469/2026-poshagovaya_instruktsiya.pdf">Пошаговая инструкция</a>
        <a class="join__item btn btn--outline-primary" target="_blank" :href="calendar?.link">Календарь {{ calendar?.text }}</a>
        <a
          class="join__item btn btn--outline-primary"
          target="_blank"
          href="https://abiturient.tusur.ru/ru/napravleniya-podgotovki/ochnaya-forma-obucheniya"
          v-if="form?.kind === 'bachelor'"
        >
          Калькулятор ЕГЭ
        </a>
      </ul>
      <div>
        <p><strong>Есть вопросы?</strong></p>
        <small>
          Тел. горячей линии: <a href="tel:+78007759025">8-800-775-9025</a> (звонок по России бесплатный)
          <br>
          Тел. приемной комиссии: <a href="tel:+73822900100">+7 (3822) 900-100</a>
        </small>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { CALENDARS } from '@shared/config'

const props = defineProps({
  form: { type: Object, default: () => ({}) }
})

const calendar = computed(() => CALENDARS.find(c => c.value === props.form?.kind))
</script>
